import React, { Component } from 'react';
import picture_pairs from '../assets/planet_pairs_little.svg';
import picture_equipe from '../assets/planet_little_equipe.svg';
import { withStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';
import PropTypes from 'prop-types';
import './ScopeModal.css'
class ScopeModal extends Component {
  constructor(props) {
    super(props);
    this.state = { pairs: false, team: false };
  }

  setPairs = () => {
    if (this.state.pairs) {
      this.setState({ pairs: false })
    } else {
      this.setState({ pairs: true })
    }
  }

  setTeam = () => {
    if (this.state.team) {
      this.setState({ team: false })
    } else {
      this.setState({ team: true })
    }
  }



  setMyScope = () => {
    this.props.setScope(this.state.pairs, this.state.team)
  }

  onDiff = () => {
    this.props.addDiffusion(this.state.pairs, this.state.team)
  }

  render() {
    const { creationLoading, classes } = this.props
    return (
      <form onSubmit={this.onSubmitChallengeInformations} method="POST">
        <div className="modal_picture text-center p-4">
          <h1 className="scope-title mb-2">À qui souhaitez-vous partager votre capsule d’amélioration ?</h1>
          <div className="p-5">
            {this.state.pairs ? <div onClick={this.setPairs} className="btn-scope-blue mb-5 cursor-pointer">
              <img className="img-scope-btn" src={picture_pairs} alt='pict-pair' />
              <h2 className="sub-btn-scope">Mes pairs</h2>
            </div> : <div onClick={this.setPairs} className="btn-scope mb-5 cursor-pointer">
                <img className="img-scope-btn" src={picture_pairs} alt='pict-my-pair' />
                <h2 className="sub-btn-scope">Mes pairs</h2>
              </div>}
            {this.state.team ? <div onClick={this.setTeam} className="btn-scope-blue cursor-pointer">
              <img className="img-scope-btn" src={picture_equipe} alt='pict-team' />
              <h2 className="sub-btn-scope">Mon équipe</h2>
            </div> : <div onClick={this.setTeam} className="btn-scope cursor-pointer">
                <img className="img-scope-btn" src={picture_equipe} alt='pict-my-team' />
                <h2 className="sub-btn-scope">Mon équipe</h2>
              </div>}
          </div>
          <button hidden={this.props.diffusion} onClick={this.setMyScope} type="submit" disabled={!this.state.pairs && !this.state.team} className="save-btn-scope">OK
          {creationLoading && <CircularProgress size={36} className={classes.buttonProgress} />}</button>

          {/* boutton de diffusion */}
          <button hidden={!this.props.diffusion} type="button" onClick={this.onDiff} disabled={!this.state.pairs && !this.state.team} className="save-btn-scope">OK
          {creationLoading && <CircularProgress size={36} className={classes.buttonProgress} />}</button>
        </div>
      </form>
    )
  }
}

const styles_loader = theme => ({
  root: {
  },
  buttonProgress: {
    color: '#0070A2',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -80,
    marginLeft: -18,
  },
});

ScopeModal.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles_loader)(ScopeModal)